import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { c as l } from "./index-SYE1cn5_.js";
import { H as i } from "./Heading-BJmz5DVg.js";
import { T as m } from "./Text-D6i4LEWL.js";
import { X as p } from "./XMarkIcon-DYnAhe7C.js";
import { C as f, T as x } from "./CircleInfoIcon-B21Ei6j1.js";
import { C as d } from "./CheckIcon-DbLatdx8.js";
const h = "_alert_16nps_1", u = "_alert__icon_16nps_9", e = {
  alert: h,
  alert__icon: u,
  "alert--info": "_alert--info_16nps_12",
  "alert--success": "_alert--success_16nps_17",
  "alert--warning": "_alert--warning_16nps_22",
  "alert--error": "_alert--error_16nps_27",
  "alert__text-container": "_alert__text-container_16nps_32",
  "alert__text-container--row": "_alert__text-container--row_16nps_36",
  "alert__text-container--column": "_alert__text-container--column_16nps_39"
}, g = {
  info: /* @__PURE__ */ r(f, {}),
  success: /* @__PURE__ */ r(d, {}),
  warning: /* @__PURE__ */ r(x, {}),
  error: /* @__PURE__ */ r(p, {})
}, b = ({
  variant: t = "info",
  direction: n,
  icon: a,
  title: _,
  text: o,
  className: c
}) => (a || (a = g[t || "info"]), /* @__PURE__ */ s(
  "div",
  {
    className: l(
      e.alert,
      e[`alert--${t}`],
      e[`alert--${n}`],
      c
    ),
    children: [
      /* @__PURE__ */ r("div", { className: e.alert__icon, children: a }),
      /* @__PURE__ */ s(
        "div",
        {
          className: l(
            e["alert__text-container"],
            e[`alert__text-container--${n}`]
          ),
          children: [
            _ && /* @__PURE__ */ r(i, { as: "p", variant: "subhead", children: /* @__PURE__ */ r("strong", { children: _ }) }),
            o && /* @__PURE__ */ r(m, { variant: "body-2", children: o })
          ]
        }
      )
    ]
  }
));
export {
  b as A
};
